export default __webpack_public_path__ + "static/media/home.1e5d55f8.png";